import http from "./api";

const get = (id) => {
  return http.get(`Intake?IntakeId=${id}`);
};
const create = (data) => {
  return http.post("Intake", data);
};
const remove = (data) => {
  return http.put(`Intake/DeleteBatch`, data);
};
const update = (data) => {
  return http.put(`Intake`, data);
};
const changeIntakeStatusId = (data) => {
  return http.put(`Intake/changeIntakeStatusId`, data);
};
const find = (params) => {
  return http.get("Intake/search?", { params });
};

const IntakeService = {
  get,
  create,
  update,
  changeIntakeStatusId,
  find,
  remove,
};

export default IntakeService;
